import { useCallback, useEffect, useMemo, useState } from 'react'

interface IFileSelectorOptions {
  accept: string
}

const useFileSelector = (
  onFile: (file: string, fileName: string) => any,
  options: Partial<IFileSelectorOptions> = {},
) => {
  const [file, setFile] = useState(null)
  const [fileName, setFileName] = useState('')

  useEffect(() => {
    if (file) {
      onFile(file, fileName)
      setFile(null)
    }
  }, [file])

  function handleRead(e) {
    setFile(null)
    setFile(e.target.result)
  }

  const handleInputChange = useCallback(e => {
    const file = e.target.files[0]
    if (!file) return

    const reader = new window.FileReader()
    reader.onload = handleRead
    const fileName = file.name
    setFileName(fileName)
    if (fileName.endsWith('.json')) {
      reader.readAsText(file)
    } else {
      reader.readAsArrayBuffer(file)
    }

    e.target.value = ''
  }, [])

  const dummy = useMemo(() => {
    const input = document.getElementById(
      'dummy-upload-file',
    ) as HTMLInputElement
    if (input) {
      // Update existing input with current options and handler
      input.onchange = handleInputChange
      if (options.accept) {
        input.accept = options.accept
      } else {
        input.removeAttribute('accept')
      }
      return input
    }

    const dummyInput = document.createElement('input')
    dummyInput.type = 'file'
    dummyInput.setAttribute('id', 'dummy-upload-file')
    dummyInput.onchange = handleInputChange
    dummyInput.style.cssText = 'display: none; visibility: hidden'
    document.body.append(dummyInput)

    if (options.accept) {
      dummyInput.accept = options.accept
    }

    return dummyInput
  }, [handleInputChange, options.accept])

  const open = () => {
    dummy.click()
  }

  return {
    open,
  }
}

export default useFileSelector
